/**
 * Case-insensitive free-text matcher for table rows.
 *
 * Returns true when the query is empty (no filtering), or when any of the
 * given fields on `item` contains the query string (case-insensitive).
 *
 * @param {Object} item - row object to test
 * @param {string} query - raw search text
 * @param {string[]} fields - field names on `item` to match against
 * @returns {boolean}
 */
export function matchesSearchQuery(item, query, fields) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return true;
  return fields.some(f =>
    (item[f] == null ? "" : String(item[f])).toLowerCase().includes(q)
  );
}
